"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const walletDetails_1 = require("../wallet/component/walletDetails");
const settlementContent_1 = __importDefault(require("./settlementContent"));
const settlementsHeader_1 = __importDefault(require("./settlementsHeader"));
const headerActions_1 = __importDefault(require("./settlementsHeader/headerActions"));
const ManageSettlements = () => {
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(settlementsHeader_1.default, {}), (0, jsx_runtime_1.jsx)(headerActions_1.default, {}), (0, jsx_runtime_1.jsx)(walletDetails_1.StyledContainer, { children: (0, jsx_runtime_1.jsx)(settlementContent_1.default, {}) })] }));
};
exports.default = ManageSettlements;
